import React from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import FieldTitle from './field-title'

const Container = styled.div`
    grid-column: span 2;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureCaptionPositionField = ({ field }: Props) => {
    return (
        <Container>
            <FieldTitle field={field} />
            Adjust position on the preview to the left.
        </Container>
    )
}

export default CreationCaptureCaptionPositionField
